/* 1996d16y5 daniel was here Savage Tech addon picker. Custom file, safe to delete on revert. */
/* Added 24 July 2026. Updated 27 July 2026 for multi instance and desktop grid. */
/* Paired with snippets/product-addons.liquid and sections/st-addon-picker.liquid */

document.addEventListener('DOMContentLoaded', function () {

  if (!document.querySelector('.st-addons')) { return; }

  // Theme wraps fetch and XHR, so cart calls go through a clean iframe fetch
  var frame = document.createElement('iframe');
  frame.style.display = 'none';
  document.body.appendChild(frame);
  var cleanFetch = frame.contentWindow.fetch.bind(frame.contentWindow);

  function strip(s) { return (s || '').replace(/<[^>]*>/g, ''); }

  function post(url, payload) {
    return cleanFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { throw d; } return d; });
    });
  }

  function refreshBubble() {
    cleanFetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count-bubble span, .cart-count-bubble, [data-cart-count], .cart-count, #CartCount, .header__cart-count')
        .forEach(function (el) { el.textContent = cart.item_count; });
    }).catch(function () {});
  }

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = cleanFetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function planId(p) {
    var g = p && p.selling_plan_groups && p.selling_plan_groups[0];
    return (g && g.selling_plans && g.selling_plans[0]) ? g.selling_plans[0].id : null;
  }

  function money(c) {
    return '$' + (c / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function textOf(html, limit) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var t = (d.textContent || '').replace(/\s+/g, ' ').trim();
    return t.length > limit ? t.slice(0, limit).replace(/\s+\S*$/, '') + '...' : t;
  }

  /* Quick view. One shared modal even when several pickers are on the page. */

  var overlay = null;
  var qvBody, qvImg, qvTitle, qvPrice, qvDesc, qvLink;

  function setupOverlay() {
    var all = document.querySelectorAll('.st-qv-overlay');
    if (!all.length) { return; }
    if (!overlay || !document.body.contains(overlay)) { overlay = all[0]; }
    all.forEach(function (el) {
      if (el !== overlay && el.parentNode) { el.parentNode.removeChild(el); }
    });
    if (overlay.parentNode !== document.body) { document.body.appendChild(overlay); }
    if (overlay.dataset.stBound) { return; }
    overlay.dataset.stBound = '1';

    qvBody = overlay.querySelector('.st-qv-body');
    qvImg = overlay.querySelector('#stQvImage');
    qvTitle = overlay.querySelector('#stQvTitle');
    qvPrice = overlay.querySelector('#stQvPrice');
    qvDesc = overlay.querySelector('#stQvDesc');
    qvLink = overlay.querySelector('#stQvLink');

    var closeBtn = overlay.querySelector('.st-qv-close');
    if (closeBtn) { closeBtn.addEventListener('click', closeQv); }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { closeQv(); } });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hidden) { closeQv(); }
    });
  }

  function closeQv() {
    if (!overlay) { return; }
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('st-qv-lock');
    document.body.classList.remove('st-qv-lock');
    setTimeout(function () { overlay.hidden = true; }, 200);
  }

  function openQv(handle, url) {
    if (!overlay) { return; }
    overlay.hidden = false;
    document.documentElement.classList.add('st-qv-lock');
    document.body.classList.add('st-qv-lock');
    qvBody.classList.add('is-loading');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    qvLink.href = url || ('/products/' + handle);

    getProduct(handle).then(function (p) {
      qvBody.classList.remove('is-loading');
      if (!p) {
        qvTitle.textContent = 'Product unavailable';
        qvPrice.textContent = '';
        qvDesc.textContent = 'We could not load this item. Open the full product page instead.';
        qvImg.removeAttribute('src');
        return;
      }
      qvTitle.textContent = p.title || '';
      qvPrice.textContent = p.price_varies ? 'From ' + money(p.price_min) : money(p.price);
      qvDesc.textContent = textOf(p.description, 420) || 'No description available.';

      var src = p.featured_image || (p.images && p.images[0]) || '';
      if (src) {
        qvImg.src = src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_600x$1$2');
        qvImg.alt = p.title || '';
      } else {
        qvImg.removeAttribute('src');
      }
    });
  }

  /* Desktop grid layout. Only applies inside the section, the product block is left alone. */

  function applyLayout(wrap) {
    var host = wrap.closest('.st-addons-section');
    if (!host) { return; }

    var rows = wrap.querySelectorAll('.st-addon-row').length;
    var from = parseInt(host.dataset.stGridFrom, 10) || 4;
    var card = host.dataset.stCard || 'auto';
    var maxWidth = host.dataset.stCardWidth || '220';

    wrap.classList.remove('st-addons--row', 'st-addons--stack');
    wrap.style.removeProperty('--st-card-max');
    wrap.style.removeProperty('--st-count');

    if (rows >= from) {
      wrap.classList.add('st-addons--row');
      wrap.style.setProperty('--st-count', rows);
      wrap.style.setProperty('--st-card-max', maxWidth + 'px');
      if (card !== 'row') { wrap.classList.add('st-addons--stack'); }
    }
  }

  /* Addon rows */

  function initWrap(wrap) {
    applyLayout(wrap);
    if (wrap.dataset.stInit) { return; }
    wrap.dataset.stInit = '1';

    wrap.querySelectorAll('.st-qv-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openQv(btn.dataset.handle, btn.dataset.url);
      });
    });

    wrap.querySelectorAll('.st-addon-row').forEach(function (row) {
      var box = row.querySelector('.st-addon-check');
      if (!box) { return; }

      var handle = box.dataset.handle;
      var select = row.querySelector('.st-addon-variant');
      var priceEl = row.querySelector('.st-addon-price');
      var thumb = row.querySelector('.st-addon-thumb img');

      if (priceEl) { priceEl.textContent = strip(priceEl.textContent); }
      getProduct(handle);

      function add() {
        var vid = select ? select.value : box.dataset.variantId;
        if (!vid) { box.checked = false; return Promise.resolve(); }
        box.disabled = true;
        return getProduct(handle).then(function (p) {
          var item = { id: parseInt(vid, 10), quantity: 1 };
          var plan = planId(p);
          if (plan) { item.selling_plan = plan; }
          return post('/cart/add.js', { items: [item] });
        }).then(function (d) {
          if (d.items && d.items[0]) { box.dataset.lineKey = d.items[0].key; }
          box.disabled = false;
          refreshBubble();
        }).catch(function (err) {
          console.error('Addon add failed:', err && (err.description || err.message || err));
          box.checked = false;
          box.disabled = false;
        });
      }

      function remove() {
        if (!box.dataset.lineKey) { box.disabled = false; return Promise.resolve(); }
        box.disabled = true;
        return post('/cart/change.js', { id: box.dataset.lineKey, quantity: 0 }).then(function () {
          delete box.dataset.lineKey;
          box.disabled = false;
          refreshBubble();
        }).catch(function (err) {
          console.error('Addon remove failed:', err && (err.description || err.message || err));
          box.checked = true;
          box.disabled = false;
        });
      }

      box.addEventListener('change', function () {
        if (box.checked) { add(); } else { remove(); }
      });

      if (select) {
        select.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
        select.addEventListener('change', function (e) {
          e.stopPropagation();
          var opt = select.options[select.selectedIndex];
          if (opt.dataset.price && priceEl) { priceEl.textContent = '+' + strip(opt.dataset.price); }
          if (thumb && opt.dataset.img) { thumb.src = opt.dataset.img; }
          box.dataset.variantId = opt.value;
          if (box.checked) { remove().then(add); }
        });
      }
    });
  }

  function initAll() {
    setupOverlay();
    document.querySelectorAll('.st-addons').forEach(initWrap);
  }

  initAll();

  // Theme editor reloads sections without a page refresh
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function () {
    if (overlay && !document.body.contains(overlay)) { overlay = null; }
  });
});